const getters = {
	appid(state) {
		return state.appid;
	},
};

export default getters